import React, { useEffect, useState } from 'react'

import { ScheduleTotals } from './ScheduleTotals/ScheduleTotals'
import { LoaderButton } from '../../../../_components/LoaderButton'
import { S_InvoicesOverview } from '../../../ClientViews/UploadInvoices/S_UploadInvoices'
import { EditScheduleTable } from './EditScheduleTable/EditScheduleTable'
import { submitInvoiceSchedule } from '../../../../_services/lender.service'
import { ScheduleFiles } from '../../lender/InvoiceSchedule/ScheduleFiles/ScheduleFiles'
import { StatusBanner } from '../../../../_components/StatusBanner'
import { S_Title } from '../../../../_components/Typography/Titles.styles'
import { S_PageHeader, S_PageHeaderRow } from '../../../../_components/layout/PageHeader/PageHeader.styles'

export const CreateInvoices = ({
  reloadSchedulePage,
  invoiceSchedule,
  business,
  isClientView = false,
  isDisabled = false,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [disabled, setDisabled] = useState(isDisabled)

  const [batchTotal, setBatchTotal] = useState(invoiceSchedule.total_value)
  const [fundedTotal, setFundedTotal] = useState(invoiceSchedule.total_funded)
  const [expectedBatchTotal, setExpectedBatchTotal] = useState(invoiceSchedule.expected_total_value)
  const [invoicesCount, setInvoicesCount] = useState(invoiceSchedule.invoices_count)

  const [invoicesErrors, setInvoicesErrors] = useState({})
  const [scheduleError, setScheduleError] = useState(null)
  const [totalInvoices, setTotalInvoices] = useState(0)

  const validateSchedule = () => {
    if (Number(batchTotal).toFixed(2) !== Number(expectedBatchTotal).toFixed(2)) {
      setScheduleError(`Batch total doesn't match expected total: ${expectedBatchTotal}`)
      setIsLoading(false)
      return false
    }
    if (!invoicesCount) {
      setScheduleError('Please add at least 1 invoice to this schedule')
      setIsLoading(false)
      return false
    }
    if (Object.keys(invoicesErrors).length !== 0) {
      setScheduleError('Please fix all invoice-specific errors prior to submitting')
      return false
    }
    setScheduleError(null)
    return true
  }

  const handleSubmitSchedule = () => {
    setIsLoading(true)
    if (invoicesErrors.length || scheduleError) {
      return
    }

    const isValid = validateSchedule()

    if (!isValid) {
      return
    }

    submitInvoiceSchedule(invoiceSchedule.id)
      .then(() => {
        reloadSchedulePage('redirect_to_client_home')
        setIsLoading(false)
      })
      .catch((response) => {
        const errors = response?.data
        if (errors) {
          setErrors(errors)
        }
        setIsLoading(false)
      })
  }

  useEffect(() => {
    validateSchedule()
  }, [expectedBatchTotal, fundedTotal, invoicesErrors])

  const setErrors = (errors) => {
    if (errors.invoice_errors && errors.invoice_errors.length) {
      let newInvoiceErrors = {}
      errors.invoice_errors.map((err) => {
        newInvoiceErrors[err.invoice_id] = err.errors
      })
      setInvoicesErrors(newInvoiceErrors)
    }
    if (errors.invoice_schedule_errors) {
      setScheduleError(errors.invoice_schedule_errors[Object.keys(errors.invoice_schedule_errors)[0]])
    }
  }

  return (
    <S_InvoicesOverview>
      <S_PageHeader>
        <S_PageHeaderRow>
          <S_Title marginBottom={'0'}>Invoice Schedule #{invoiceSchedule.batch_number}</S_Title>
          {scheduleError && <StatusBanner className={`error`} icon="error" message={scheduleError} />}
        </S_PageHeaderRow>
      </S_PageHeader>

      <div className={`business-selection`}>
        <div className="left">
          <ScheduleTotals
            batchTotal={batchTotal}
            disabled={disabled}
            expectedBatchTotal={expectedBatchTotal}
            fundedTotal={fundedTotal}
            invoiceSchedule={invoiceSchedule}
            isClientView={isClientView}
            setExpectedBatchTotal={setExpectedBatchTotal}
          />
        </div>
        <div className="right">
          <LoaderButton disabled={scheduleError || disabled} isLoading={isLoading} onClick={handleSubmitSchedule}>
            Review
          </LoaderButton>
        </div>
      </div>

      <EditScheduleTable
        business={business}
        disabled={disabled}
        invoiceSchedule={invoiceSchedule}
        isClientView={isClientView}
        isLoading={isLoading}
        reloadSchedulePage={reloadSchedulePage}
        setBatchTotal={setBatchTotal}
        setFundedTotal={setFundedTotal}
        setInvoicesCount={setInvoicesCount}
        setInvoicesErrors={setInvoicesErrors}
        setIsLoading={setIsLoading}
        setTotalInvoices={setTotalInvoices}
      />

      <ScheduleFiles invoiceSchedule={invoiceSchedule} isClientView={isClientView} totalInvoices={totalInvoices} />
    </S_InvoicesOverview>
  )
}
